import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { OutOfOfficeService } from '../../../Model/OutOfOffice/out-of-office.service';

@Component({
  selector: 'app-out-of-office',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent],
  templateUrl: './out-of-office.component.html',
  styleUrl: './out-of-office.component.scss'
})
export class OutOfOfficeComponent {
  isDisabled: boolean = false;
  RegularData: any[] = [];
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private download: DownloadSampleService,
    private toast: ToastService,
    private outofoffice: OutOfOfficeService,
  ) {
    this.common.getPageRights();
    // this.common.PageRight.IsView = true;
    // this.common.PageRight.IsAdd = true;
    // this.common.PageRight.IsDelete = true;
    // this.common.PageRight.IsEdit = true;
    // this.common.PageRight.IsPrint = true;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.OutOfOfficePolicies();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  OutOfOfficePolicies() {
    this.isDisabled = true;
    this.outofoffice.OutOfOfficeRuleLoad({ SelectType: 1, ESS_OutOfOfficeRuleID: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.TableDatas.forEach((element:any) => {
          element.WebESSApplicability = response.Table1.filter((e:any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
        });
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  // exportToExcel() {
  //   this.isDisabled = true
  //   const data = {
  //     SelectType: 'RegularizationPolicyMasterExcel',
  //     Year: ''
  //   }
  //   this.download.ESS_ExcelDump(data).subscribe(
  //     data => {
  //       this.RegularData = data;
  //       if (this.RegularData.length > 0) {
  //         this.download.exportToExcel(this.RegularData, "RegularizationPolicies_data");
  //         this.isDisabled = false
  //       }
  //       else {
  //         this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
  //         this.isDisabled = false
  //       }
  //     });
  // }
}
